import {PATHS} from "../../../../routing/paths";
import {
    CEO,
    CONTACT,
    INN,
    KPP,
    LEGAL_ADDRESS,
    OGRN,
    OPERATOR,
    OPERATOR_SHORT,
    SERVICE,
    type LegalDoc,
} from "./common";

/** Пользовательское соглашение (/terms). */
export const TERMS_DOC: LegalDoc = {
    title: "Пользовательское соглашение",
    linkLabel: "пользовательское соглашение",
    path: PATHS.terms,
    updated: "19 октября 2026 г.",
    sections: [
        {
            title: "1. Общие положения",
            body: [
                `Настоящее Пользовательское соглашение (далее — Соглашение) регулирует отношения между ${OPERATOR} (далее — Администрация/Оператор), ИНН ${INN}, КПП ${KPP}, ОГРН ${OGRN}, юридический адрес: ${LEGAL_ADDRESS}, и пользователем — физическим лицом, зарегистрировавшимся в сервисе ${SERVICE} (далее — Сервис).`,
                `Генеральный директор Оператора: ${CEO}.`,
                "Регистрируясь, вы подтверждаете, что ознакомились с условиями Соглашения, Политикой обработки персональных данных, Офертой, Согласием на обработку персональных данных и Согласием на получение рассылки, и принимаете их в полном объёме.",
            ],
        },
        {
            title: "2. Предмет Соглашения",
            body: [
                "Администрация предоставляет Пользователю доступ к программному сервису знакомств, включая создание анкеты, просмотр анкет других пользователей, обмен сообщениями, расчёт совместимости и иные функции.",
                "Premium-подписка предоставляет расширенные возможности Сервиса на оплаченный период. В рамках Premium-подписки предоставляется 15 супер симпатий на каждый 30-дневный период подписки, отсчитываемый от даты оплаты; неиспользованные за период супер симпатии сгорают в конце периода и не переносятся на следующий. Приобретённые пакеты и стартовые супер симпатии не сгорают.",
                "Сервис предоставляется на условиях «как есть» (as is). Администрация не гарантирует достижения каких-либо результатов знакомств.",
            ],
        },
        {
            title: "3. Регистрация и учётная запись",
            body: [
                "Сервис предназначен только для лиц, достигших 18 лет. Регистрируясь, вы подтверждаете своё совершеннолетие.",
                "Один пользователь может иметь только одну учётную запись. Запрещается передавать доступ к учётной записи третьим лицам.",
                "Вы обязуетесь указывать достоверные данные в профиле и размещать только собственные фотографии.",
                "При регистрации вы даёте согласие на обработку персональных данных и на получение рекламной/новостной рассылки в порядке, установленном соответствующими документами.",
            ],
        },
        {
            title: "4. Запрещённые действия",
            body: [
                "Запрещается: размещение оскорбительного, порнографического или иного противоправного контента; спам и сторонняя реклама; мошенничество, вымогательство, угрозы; выдача себя за другое лицо; сбор и распространение персональных данных других пользователей; использование автоматизированных средств доступа к Сервису.",
                "За нарушение правил Администрация вправе ограничить доступ к отдельным функциям, заблокировать или удалить учётную запись без возмещения стоимости приобретённых услуг.",
                "Запрещается недобросовестное участие в бонусной программе: массовые регистрации, само-приглашения, иные попытки искусственного накопления баллов. Такие баллы и полученные с их помощью промокоды аннулируются (подробнее — раздел «Бонусная программа» Публичной оферты).",
            ],
        },
        {
            title: "5. Контент пользователей",
            body: [
                "Права на размещаемый контент сохраняются за вами. Размещая контент, вы предоставляете Администрации неисключительное право использовать его в объёме, необходимом для работы Сервиса (показ другим пользователям, хранение, техническая обработка).",
                "Администрация вправе удалять контент, нарушающий настоящее Соглашение или законодательство РФ, в том числе по требованию Роскомнадзора или иных уполномоченных органов.",
            ],
        },
        {
            title: "6. Персональные данные и конфиденциальность",
            body: [
                `Обработка персональных данных осуществляется ${OPERATOR_SHORT} в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» и Политикой обработки персональных данных, размещённой по адресу ${PATHS.privacy}.`,
                "Персональные данные обрабатываются на территории Российской Федерации.",
                "Пользователь вправе в любой момент отозвать согласие на обработку персональных данных путём направления обращения в поддержку.",
            ],
        },
        {
            title: "7. Ответственность",
            body: [
                "Администрация не несёт ответственности за действия пользователей вне и внутри Сервиса, а также за достоверность информации, размещённой пользователями.",
                "Расчёты совместимости (астрологический, нумерологический анализ и иные) носят развлекательный характер и не являются рекомендациями.",
                "Будьте осмотрительны при общении и личных встречах. О нарушениях сообщайте через кнопку «Пожаловаться» или в поддержку.",
            ],
        },
        {
            title: "8. Изменение и расторжение Соглашения",
            body: [
                "Администрация вправе изменять Соглашение, уведомляя пользователей публикацией новой редакции на этой странице. Продолжение использования Сервиса означает согласие с изменениями.",
                "Пользователь вправе удалить учётную запись в любой момент в настройках профиля.",
                `Вопросы по Соглашению: ${CONTACT}.`,
            ],
        },
    ],
};
